<template>
  <div width="100%">
    <div v-if="chemical">
      <ChemCard
        :item="chemical"
        :show-details="showDetails"
        :use-own-image="useOwnImage"
      />
    </div>
    <div
      v-if="showDetails"
      style="font-size: smaller; max-width: 500px"
    >
      <div
        :style="original && this.highlightDiff && chemical.name !== original.name ? 'color:red;' : ''"
        class="ml-1 mb-1"
      >
        <span
          title="Name"
          v-html="this.mark(chemical.name)"
        />
      </div>
      <div class="ml-1 mb-1">
        <span
          :style="original && this.highlightDiff && chemical.casrn !== original.casrn ? 'color:red;' : ''"
          title="CAS RN"
          v-html="this.mark(chemical.casrn)"
        />
      </div>
      <div
        class="ml-1 mb-1"
        style=""
      >
        <span
          :style="original && this.highlightDiff && chemical.smiles !== original.smiles ? 'color:red;' : ''"
          title="Smiles"
        >
          {{ chemical.smiles }}
        </span>
      </div>
      <div
        :style="
          original && this.highlightDiff && chemical.canonicalSmiles !== original.canonicalSmiles ? 'color:red;' : ''
        "
        class="ml-1 mb-1"
      >
        <span title="Canonical smiles">{{ chemical.canonicalSmiles }}</span>
      </div>
      <div
        :style="original && this.highlightDiff && chemical.inchi !== original.inchi ? 'color:red;' : ''"
        class="ml-1 mb-1"
      >
        <span title="Inchi">{{ chemical.inchi }}</span>
      </div>
      <div
        :style="original && this.highlightDiff && chemical.inchiKey !== original.inchiKey ? 'color:red;' : ''"
        class="ml-1 mb-1"
      >
        <span
          title="Inchi Key"
          v-html="this.mark(chemical.inchiKey)"
        />
      </div>
      <div class="ml-1 mb-1">
        <span title="Chem ID">
          <a
            v-if="linktype === 'pubchem'"
            :href="'https://pubchem.ncbi.nlm.nih.gov/compound/' + chemical.cid"
            target="_blank"
          >
            {{ chemical.cid }}
          </a>
          <a
            v-if="linktype === 'dsstox'"
            :href="'https://comptox.epa.gov/dashboard/chemical/details/' + chemical.sid"
            target="_blank"
          >
            {{ chemical.sid }}
          </a>
          <a
            v-if="linktype === 'comchem'"
            :href="'https://commonchemistry.cas.org/detail?cas_rn=' + chemical.casrn"
            target="_blank"
          >
            {{ chemical.casrn }}
          </a>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import ChemCard from '@/components/chemical/ChemCard.vue'

export default {
  components: { ChemCard },
  props: {
    useOwnImage: {
      type: Boolean,
      required: false,
      default: false,
    },
    item: {
      type: Object,
      required: true,
    },
    linktype: {
      type: String,
      required: true,
    },
    searchText: {
      type: String,
      required: false,
    },
    original: {
      type: Object,
    },
    showDetails: {
      type: Boolean,
      default: false,
    },
    highlightDiff: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    chemical() {
      return this.item == null ? null : this.item.chemical ? this.item.chemical : this.item
    },
  },
  methods: {
    mark(text) {
      return this.searchText ? text.replaceAll(this.searchText, '<mark>' + this.searchText + '</mark>') : text
    },
  },
}
</script>

<style lang="scss">
mark {
  background-color: HotPink;
}
</style>
